import React from "react";
import CustomerLinksTable from "../../../Components/Agent/SearchAgent/CustomerLinksTable/CustomerLinksTable";
import CrmHubPage from "../Crm/CrmHubPage";
import { useCrmHubEnabled } from "../../../utils/useCrmHubEnabled";
import "./SalesLinks.scss";

/**
 * drafts pageType → CRM Hub when enabled (phase 1: platform admins only);
 * otherwise legacy offers table. sales-links stays offers-only.
 */
const SalesLinks = ({ pageType = "sales-links" }) => {
  const crmHubEnabled = useCrmHubEnabled();

  if (pageType === "drafts" && crmHubEnabled) {
    return <CrmHubPage />;
  }

  return (
    <div className="sales-links-page">
      <div className="sales-links-container">
        <CustomerLinksTable pageType={pageType} />
      </div>
    </div>
  );
};

export default SalesLinks;
